import React from 'react';

import { Box } from '@wds/box';
import { Input } from '@wds/input';

export default class VideoLink extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			videoLink: props.videoLink || '',
			width: props.width || '',
			height: props.height || ''
		};
	}
	onChange = (e) => {
		const { insertVideo } = this.props;
		this.setState({
			videoLink: e.target.value
		});
		this.props.insertVideo(e.target.value, 'videoLink');

	}
	onChangeWidth = (e) => {
		const { insertVideo } = this.props;
		this.setState({
			width: e.target.value
		});
		this.props.insertVideo(e.target.value, 'width');

	}
	onChangeHeight = (e) => {
		const { insertVideo } = this.props;
		this.setState({
			height: e.target.value
		});
		this.props.insertVideo(e.target.value, 'height');

	}

	render() {
		return (
			<React.Fragment>
				<Box mt={3}>
					<Input
						label={ gettext('Video link:') }
						value={this.state.videoLink}
						stretched
						onChange={this.onChange}
						type="text"
						placeholder={ gettext('Paste video link here') }
					/>
				</Box>
				<Box mt={3}>
					<Input
						label={ gettext('Width:') }
						value={this.state.width}
						onChange={this.onChangeWidth}
						type="number"
						placeholder={ gettext('Width') }
					/>
					<Input
						label={ gettext('Height:') }
						value={this.state.height}
						onChange={this.onChangeHeight}
						type="number"
						placeholder={ gettext('Height') }
					/>
				</Box>
			</React.Fragment>
		);
	}
}
